module.exports = __webpack_public_path__ + "static/media/Gajanan Bhusanur.cf681ca8.jpg";